import styled from "styled-components"
import { MIN_INFO_WIDTH } from "@root/common"

const LowerInfoStyled = styled.div`
    position: relative;
    height: 50%;
    width: 100%;

    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10%;
    padding: 2.5%;

    @media (max-width: calc(2 * ${MIN_INFO_WIDTH})) {
        height: auto;
        flex-shrink: 0;
    }

    & > div.orderbook {
        position: relative;
        width: 100%;
        height: 100%;

        display: grid;
        grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
        align-content: space-around;

        @media (max-width: calc(2 * ${MIN_INFO_WIDTH})) {
            height: auto;
        }

        div.headers {
            display: grid;
            grid-template-columns: subgrid;
            grid-column: 1 / -1;
            width: 100%;

            h3:first-child {
                text-align: left;
            }

            h3:last-child {
                text-align: right;
            }
        }

        &.single-order {
            align-content: start;
            grid-template-rows: auto 1fr;

            .orders-centered {
                grid-column: 1 / -1;
                display: grid;
                grid-template-columns: subgrid;
                align-content: center;
                min-height: 0;
            }

            @media (max-width: calc(2 * ${MIN_INFO_WIDTH})) {
                grid-template-rows: auto auto;

                .orders-centered {
                    min-height: 5em;
                }
            }
        }
    }
`

export {LowerInfoStyled}
